<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">전자 계약</span>
            <span class="txt">
                발송한 계약서 내역을 확인하고, 자주 쓰는 템플릿(서식)을 등록하거나 수정할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link
                        v-show="item.valid"
                        :class="{ on: $route.name == item.name }"
                        :to="{ ...item, params: { centerId } }"
                    >
                        {{ item.label }}
                    </router-link>
                </span>
            </div>
            <div class="table-top-container" style="margin-top: 30px; display: block">
                <div style="display: flex">
                    <p class="table-top-title"><strong>알림톡 수신</strong></p>
                    <div class="com-tooltip">
                        <button class="icon"></button>
                        <div class="detail">
                            <p class="txt">계약 진행 사항을 수신할 대표 연락처를 설정합니다.</p>
                        </div>
                    </div>
                </div>
                <select-form
                    style="margin-top: 20px"
                    :select-data="staffList"
                    :select-value="staffIdList"
                    :selected-value="representative"
                    @update:set="(val) => setCenterRepresentative(val)"
                ></select-form>
            </div>
            <div class="table-top-container" style="margin-top: 30px; display: block">
                <p class="table-top-title"><strong>계약서 대표</strong></p>
                <div
                    v-show="repSignatureName != ''"
                    style="
                        border: solid 1px #e1e1e1;
                        background: #f9f9f9;
                        padding: 7px 10px;
                        margin-top: 20px;
                        width: fit-content;
                    "
                >
                    {{ repSignatureName }}
                </div>
            </div>
            <div class="table-top-container" style="margin-top: 30px">
                <div class="left-box">
                    <p class="table-top-title"><strong>서명 목록</strong></p>
                </div>
                <div class="right-box">
                    <a class='com-btn white' @click='onSignatureRegister' style='color: black !important;'>서명 등록</a>
                </div>
            </div>
            <div style="display: flex; flex-wrap: wrap">
                <div class="signature-item" v-for="(item, index) in signatureList" :key="index">
                    <img class="signature-item-img" :src="item.f_file_url" @click="onEditSignature(index)" />
                    <button
                        class="com-btn green signature-item-representative"
                        :class="`${item.s_rep ? '' : 'inactive'}`"
                        @click="setRepresentative(index)"
                    >
                        대표
                    </button>
                    <div class="signature-item-title" @click="onEditSignature(index)">{{ item.s_name }}</div>
                    <img class="signature-item-delete" src="/img/icons/icon_locker_del.png" @click="onDelete(index)" />
                </div>
            </div>
        </template>
        <div v-show="signaturePop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeSignaturePopup">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">
                        서명 {{ selectedIndex == -1 ? '등록' : '수정' }}
                    </p>
                    <div style="display: flex; align-items: center; margin-bottom: 15px">
                        <span class="tit" style="margin-right: 30px">
                            서명자명
                            <span class="imp">*</span>
                        </span>
                        <input
                            v-model="signerName"
                            placeholder=""
                            type="text"
                            style="flex: 1"
                            maxlength="8"
                            @keydown="onKeydownOnlySpace($event)"
                        />
                    </div>
                    <img v-show="imgSrc !== ''" style='position: absolute; object-fit: contain;' id='img_signature_pad' width='500' height='300' :src="imgSrc"></img>
                    <canvas style='position:relative; touch-action: auto; user-select: auto' class='signature-container register' id='canvas_signature_pad' width='500' height='300'></canvas>
                    <div style="display: flex; align-items: center; margin-top: 15px">
                        <span class="tit" style="margin-right: 30px">이미지 업로드</span>
                        <input v-model="fileName" class="design-input" readonly type="text" style="flex: 1" />
                        <button class="com-btn" @click="onBrowse">찾아보기</button>
                        <b-form-file
                            id="file1"
                            accept=".jpg, .png, .gif"
                            style="display: none"
                            plain
                            @change="handleFile"
                        ></b-form-file>
                    </div>
                    <div class="bottom-btn" style="margin-top: 30px; padding-bottom: 0">
                        <button class="com-btn" @click="onCancel">취소</button>
                        <button class="com-btn blue" @click="onSave" :disabled="selectedIndex > -1 && !edited">
                            저장
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import SignaturePad from 'signature_pad';

export default {
    name: 'SettingElectronicSignature',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {
        signerName: function (newValue) {
            this.checkEdited(newValue);
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            centerId: 0,

            submenus: [
                { name: 'SettingElectronicContractManage', label: '계약 관리' },
                { name: 'SettingElectronicExternalDocument', label: '외부 문서' },
                { name: 'SettingElectronicTemplateManage', label: '템플릿 관리' },
                { name: 'SettingElectronicSignature', label: '서명' },
                { name: 'SettingElectronicSetting', label: '설정' },
            ],

            isLoading: false,

            signaturePop: false,
            signaturePad: null,

            signatureList: [],

            signerName: '',
            fileName: '',
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data
            fileGroupId: 0,
            selectedIndex: -1,
            repSignatureName: '',
            edited: false,
            editedFile: false,

            staffList: [],
            staffIdList: [],
            representative: 0,
            imgSrc: ""
        };
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;
            this.centerId = parseInt(this.cId); // 센터id

            this.setSubMenu();
            this.setSignaturePad();

            this.getSignatureList();

            this.getCenterStaffList();

            this.isLoading = false;
        },

        async setCenterRepresentative(newValue) {
            this.representative = newValue;

            try {
                this.isLoading = true;

                const response = await api.post(
                    `/admin/api/center/set/representative/staff/${this.centerId}/${this.representative}`
                );
                if (response && response.data) {
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        onKeydownOnlySpace(event) {
            if (event.keyCode == 32) {
                return event.preventDefault();
            }
        },

        setSubMenu() {
            this.submenus[0].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[1].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[2].valid = this.isAllowed('ME', 6);
            this.submenus[3].valid = this.isAllowed('ME', 6);
            this.submenus[4].valid = this.isAllowed('ME', 6);
        },

        async getSignatureList() {
            try {
                this.isLoading = true;

                const response = await api.get(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature`
                );
                if (response && response.data) {
                    this.signatureList = response.data;
                    this.repSignatureName = '';
                    this.signatureList.map((item) => {
                        if (item.s_rep) {
                            this.repSignatureName = item.s_name;
                        }
                    });
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async getCenterInfo() {
            try {
                const response = await api.get(`/admin/api/center/${this.centerId}`);
                if (response && response.data && response.data.representativeStaffId) {
                    if (this.staffIdList.filter((it) => it == response.data.representativeStaffId)) {
                        this.representative = response.data.representativeStaffId;
                    }
                }
            } catch (error) {
                console.error('API Request Fail:', error);
            }
        },

        async getCenterStaffList() {
            try {
                this.isLoading = true;

                const response = await api.get(`/admin/api/center/staff/list/${this.centerId}`);
                if (response && response.data) {
                    this.staffList.push('선택');
                    this.staffIdList.push(0);

                    response.data.map((it) => {
                        this.staffList.push(it.name);
                        this.staffIdList.push(it.centerStaffId);
                    });

                    this.getCenterInfo();
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async setRepresentative(index) {
            try {
                this.isLoading = true;

                const response = await api.put(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature/rep`,
                    {
                        id: this.signatureList[index].s_id,
                    }
                );
                if (response && response.data) {
                    this.signatureList = response.data;
                    this.repSignatureName = '';
                    this.signatureList.map((item) => {
                        if (item.s_rep) {
                            this.repSignatureName = item.s_name;
                        }
                    });
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        setSignaturePad() {
            const canvas = document.querySelector('#canvas_signature_pad');
            this.signaturePad = new SignaturePad(canvas);

          this.signaturePad.addEventListener("startStroke", () => {
            this.imgSrc = '';
          }, { once: false });
            this.signaturePad.addEventListener("endStroke", () => {
              this.imgSrc = '';
                const file = Utils.getFileFromRawImageData(this.signaturePad.toDataURL());
                this.setUploadFile(file);
                this.editedFile = true;
                this.checkEdited();
            }, { once: false });
        },

        onSignatureRegister() {
            this.initAddPop();

            this.signaturePop = true;
        },

        onEditSignature(index) {
            this.initAddPop();

            const signature = this.signatureList[index];

            this.selectedIndex = index;

            this.fileGroupId = signature.s_file_group_id;
            this.signerName = signature.s_name;

            const fileUrl = signature.f_file_url;
            const paths = fileUrl.split('/');
            this.fileName = paths[paths.length - 1];

            // let img = new Image();
            // img.src = signature.f_file_url;
            //
            // const canvas = document.querySelector("#canvas_signature_pad");
            // canvas.getContext("2d").drawImage(img, 0, 0, 500, 300);

            this.signaturePop = true;
        },

        checkEdited(title) {
            if (title == undefined) {
                title = this.signerName;
            }
            const signature = this.signatureList[this.selectedIndex];
            if (this.selectedIndex == -1) {
                this.edited = false;
            } else {
                if (signature.s_name == title && !this.editedFile) {
                    this.edited = false;
                } else {
                    this.edited = true;
                }
            }
        },

        async onDelete(index) {
            if (confirm('서명을 삭제하시겠습니까?')) {
                try {
                    this.isLoading = true;

                    const response = await api.delete(
                        `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature/${this.signatureList[index].s_id}`
                    );
                    if (response && response.data) {
                        this.signatureList = response.data;
                        this.repSignatureName = '';
                        this.signatureList.map((item) => {
                            if (item.s_rep) {
                                this.repSignatureName = item.s_name;
                            }
                        });
                    }

                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            }
        },

        closeSignaturePopup() {
            this.signaturePop = false;
        },

        onCancel() {
            if (this.selectedIndex == -1) {
                this.closeSignaturePopup();
                return;
            }

            if (
                this.signatureList[this.selectedIndex].s_name == this.signerName &&
                this.signatureList[this.selectedIndex].s_file_group_id == this.fileGroupId
            ) {
                this.closeSignaturePopup();
            } else {
                if (confirm('서명정보가 변경되었습니다. 취소하시겠습니까?')) {
                    this.closeSignaturePopup();
                }
            }
        },

        initAddPop() {
            this.selectedIndex = -1;
            this.signerName = '';
            this.imgSrc = '';
            this.signaturePad.clear();
            this.fileName = '';
            this.uploadFiles = [];
            this.edited = false;
            this.editedFile = false;
        },

        async onSave() {
            if (this.signerName == '') {
                alert('서명자명을 입력해주세요.');
                return;
            }

            if (this.fileName == '' && this.signaturePad.toDataURL() == '') {
                alert('서명이미지를 선택하거나 서명이미지를 그려주세요.');
                return;
            }

            if (this.selectedIndex == -1) {
                if (!confirm('서명을 등록하시겠습니까??')) {
                    return;
                }
            } else {
                if (
                    this.signatureList[this.selectedIndex].s_name == this.signerName &&
                    this.signatureList[this.selectedIndex].s_file_group_id == this.fileGroupId &&
                    !this.editedFile
                ) {
                    alert('변경된 정보가 없습니다.');
                    return;
                }

                if (!confirm('서명을 수정하시겠습니까?')) {
                    return;
                }
            }

            const { data } = await api.post(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature`,
                {
                    id: this.selectedIndex == -1 ? 0 : this.signatureList[this.selectedIndex].s_id,
                    name: this.signerName,
                    uploadFiles: this.uploadFiles,
                    fileGroupId: this.fileGroupId,
                }
            );

            if (data) {
                if (this.selectedIndex == -1) {
                    alert('서명이 등록되었습니다.');
                } else {
                    alert('서명이 수정되었습니다.');
                }

                this.getSignatureList();

                this.closeSignaturePopup();
            }
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        async onBrowse() {
            document.querySelector('#file1').click();
        },

        // File 핸들러
        async handleFile(e) {
            try {
                const file = e.target.files[0];
                this.imgSrc = '';
                this.signaturePad.clear();
                this.setUploadFile(file)
                this.editedFile = true;
                this.checkEdited();
            } catch (error) {
                console.log(error);
                alert('파일을 첨부하는 중 오류가 발생했습니다.');
            }
        },

        async setUploadFile(file) {
            let base64data = await this.readFileAsync(file);
            this.base64data = base64data; // 이미지 미리보기
            base64data = base64data.split(',')[1];
            if (base64data === undefined) {
                alert('빈 파일은 첨부할 수 없습니다.');
                return;
            }
            const fileInfo = {
                filename: file.name,
                mimetype: file.type,
                base64data: base64data,
                type: 1,
            };
            //this.signaturePad.canvas.getContext("2d").drawImage(base64data, 0, 0)
          this.imgSrc = this.base64data
            this.fileName = fileInfo.filename;
            this.uploadFiles = [fileInfo];
        },
    },
};
</script>
<style lang="scss"></style>
